<div class="w-full h-full grid grid-rows-10 p-[2%]">
    <div class="grid grid-cols-2 h-[2vh]">
        <div class="justify-start">
            <h3 class="exclusion-name">{{windowName}}</h3>
        </div>
        <div class="flex justify-end">
            <span class=" " mat-dialog-close mat-icon-button style="cursor: pointer" (click)=closeDialogBox()>
            <mat-icon [svgIcon]="'custom:close'"></mat-icon>
        </span>
        </div>   
    </div>

    <div class="h-[1vh] pt-[2vh]">
        <hr class="relative top-[0vh] ">        
    </div>

    <div class="grid grid-rows-8 row-span-3 pt-[2vh]">
        <div class=" grid grid-cols-2">
            <div class="content-heading">Duration</div>
            <div class="content-value">{{displayExclusionDetails.periodFrom}} - {{displayExclusionDetails.periodTo}}</div>
        </div>
        <div class=" grid grid-cols-2 pt-[1vh]">
            <div class="content-heading">Chainage Range</div>
            <div class="content-value">{{displayExclusionDetails.start_chainage}} - {{displayExclusionDetails.end_chainage}}</div>
        </div>
        <div class=" grid grid-cols-2 pt-[1vh]">
            <div class="content-heading">Direction</div>
            <div class="content-value">{{(displayExclusionDetails["lhs/rhs"]) === "both" ? 'LHS and RHS' : displayExclusionDetails["lhs/rhs"].toUpperCase()}}</div>
        </div>
        <div class=" grid grid-cols-2 pt-[1vh]">
            <div class="content-heading">Side</div>
            <div class="content-value">{{((displayExclusionDetails["shoulder/median"]).toLowerCase() === "both".toLowerCase() || (displayExclusionDetails["shoulder/median"]) === "2") ? 'Shoulder and Median' : displayExclusionDetails["shoulder/median"]}}</div>
        </div>
        <div class=" grid grid-cols-2 pt-[1vh]">
            <div class="content-heading">Reason of Exclusion</div>
            <div class="content-value line-clamp-2  w-[16vw]">
                {{(dashboardService.translate(displayExclusionDetails.reason) || '-') |
                            titlecase}}</div>
        </div>
        
        <div *ngIf="!confirmCall" class="grid grid-cols-2 pt-[1vh] row-span-3">
            <div class="content-heading">Inventory Name</div>
            <div class="content-value overflow-y-scroll w-[16vw] h-[25vh]" >
                <p *ngFor="let asset of displayExclusionDetails.use_cases;let i = index">
                    {{asset.replaceAll('_',' ')}}</p>
            </div>
        </div>
        <div *ngIf="confirmCall" class=" grid grid-cols-2 pt-[1vh] row-span-3">
            <div class="content-heading">Inventory Name</div>
            <div class="content-value overflow-y-scroll w-[16vw] h-[25vh]" >
                <mat-checkbox class="py-2 pl-5 w-[100%] " [checked]="isChecked(asset)" (change)="checkAssets(asset)"  style="height: 1px !important;"
                 *ngFor="let asset of shiftDataService.selectedAssetIdsForExclusion">
                    <p>{{asset.asset_name}}</p>
                </mat-checkbox>
            </div>
        </div> 
    </div>
    <div class="grid justify-end pt-[3vh]">
        <button class="okBtn hover:shadow-lg" *ngIf="btnText.toLowerCase() != 'OK'.toLowerCase()" [ngClass]="isSaveEnable() ? 'enable-save' : 'disable-save'" (click)=saveExclusion()>
            <p class="okText">{{btnText}}</p>
        </button>
        <button class="okBtn hover:shadow-lg" *ngIf="btnText.toLowerCase() === 'OK'.toLowerCase()" (click)=closeDialogBox()>
            <p class="okText">{{btnText}}</p>
        </button>
        
    </div>
</div>